module.exports = __webpack_public_path__ + "static/media/singapore-white.8f70fa6d.svg";